import styled from 'styled-components';

export const DeploymentWrapper = styled.div`
  padding: 16px 24px;
`;

export const Title = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  margin-bottom: 24px;
`;

export const ContentWrapper = styled.div<{ status: 'success' | 'failed' | 'inprogress' | null }>`
  display: flex;
  padding: 16px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: ${({ status }) => {
    if (status === 'success') {
      return '#F6FFED';
    } else if (status === 'failed') {
      return '#FFF1F0';
    } else if (status === 'inprogress') {
      return '#F2F6FF';
    }
    return '';
  }};
  margin-bottom: 48px;
`;

export const SuccessTitle = styled.div`
  color: #52c41a;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.16px;
  margin-bottom: 16px;
`;

export const SuccessInfo = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
